import { Component, Inject} from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';
import { EqualValidator } from '../../../helper/equal.validator';
import { UsersDataManager } from '../../../data/users.datamanager';
import { ErrorResponse } from '../../../data/model/errorResponse';

@Component({
    selector   : 'profile-dialog',
    templateUrl: './profile-dialog.html'
})
export class ProfileDialogComponent
{
    password = new FormControl('', [Validators.required, Validators.minLength(8)]);
    oldPassword = new FormControl('', [Validators.required]);
    secondPassword = new FormControl('', [Validators.required]);
    passwordEqual = false;
    errorMessage = '';

    constructor( 
        public dialogRef: MatDialogRef<ProfileDialogComponent>,
        public usersDataManager: UsersDataManager,
        public snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: any)
    {
    }

    public validatePassword() { 
        let first = this.password.value;
        let second = this.secondPassword.value;
        if(first === second){
            this.passwordEqual = true;
            this.errorMessage = ''
        }else{
            this.passwordEqual = false;
        }
      }

    getPasswordErrorMessage()
    {
        return this.password.hasError('required') ? 'You must enter a new password' :
            this.password.hasError('minlength') ? 'Password should be at least 8 characters long' :
                '';
    }
    getOldPasswordErrorMessage()
    {
        return this.password.hasError('required') ? 'You must enter your old password' :
                '';
    }
    getSecondPasswordErrorMessage()
    {
            return this.secondPassword.hasError('required') ? 'You must enter the new password' :
            '';
    }

    buttonClicked(data){
        if(!this.passwordEqual){
            this.errorMessage = 'New Password and repeated password should be the same'
        }else{
            this.errorMessage = ''
            this.usersDataManager.updateUserPassword(data.response._id, data.oldPassword, data.password).subscribe(
                (res) => {
                    this.closeDialogSuccess('Password changed succesfully');
                },
                (err) => {
                   this.errorMessage = err.json();
                }
            );
        }
    }

    onNoClick(): void
    {
        this.dialogRef.close();
    }

    closeDialogWithError(error: ErrorResponse){
        this.dialogRef.close(error);
    }
    
    closeDialogSuccess(message: string){
        this.dialogRef.close(message);
    }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/toolbar/profile/profile.dialog.component.ts